import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4">Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> 19th April, 2025
      </p>

      <p>
        This Privacy Policy describes how the Nursing and Midwifery Council of
        Nigeria (“NMCN”, “we”, “our”, or “us”) collects, uses, discloses, and
        protects the personal information of nursing professionals who register
        and use this platform for the purpose of serving as examiners in the
        Council’s professional examinations.
      </p>

      <p>
        By accessing or using this website, you agree to the terms of this
        Privacy Policy.
      </p>

      <h2 className="mt-5">1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Identification Information:</strong> Full name,
          gender, date of birth, passport photograph, contact address, phone
          number, email address, and other similar information.
        </li>
        <li>
          <strong>Professional Information:</strong> Nursing license number,
          professional qualifications, employment details, years of experience,
          area of specialization, previous examiner experience, and availability
          for postings.
        </li>
        <li>
          <strong>Technical and Usage Data:</strong> IP address, browser type,
          device information, access times, pages viewed, and other usage data
          when interacting with the website.
        </li>
      </ul>

      <h2 className="mt-5">2. How We Use Your Information</h2>
      <ul>
        <li>To process and manage your registration as an examiner.</li>
        <li>
          To verify your credentials and eligibility to serve as an examiner.
        </li>
        <li>To assign and manage your postings during Council examinations.</li>
        <li>
          To communicate with you regarding assignments, updates, and Council
          activities.
        </li>
        <li>
          To maintain accurate and up-to-date records for regulatory and
          administrative purposes.
        </li>
        <li>To ensure the security and functionality of our platform.</li>
      </ul>

      <h2 className="mt-5">3. Information Sharing and Disclosure</h2>
      <ul>
        <li>
          <strong>Internally within NMCN:</strong> With relevant departments and
          authorized personnel for examiner administration purposes.
        </li>
        <li>
          <strong>With third-party service providers:</strong> Who perform
          services on our behalf such as hosting, IT support, and communication
          services. These third parties are contractually obligated to safeguard
          your data.
        </li>
        <li>
          <strong>As required by law:</strong> We may disclose information if
          required to do so by law or in response to valid legal processes.
        </li>
      </ul>
      <p>We do not sell, rent, or trade your personal data.</p>

      <h2 className="mt-5">4. Data Security</h2>
      <p>
        We implement appropriate administrative, technical, and physical
        safeguards to protect your information from unauthorized access, loss,
        misuse, or disclosure. However, no method of electronic transmission or
        storage is completely secure. Therefore, we cannot guarantee absolute
        security.
      </p>

      <h2 className="mt-5">5. Data Retention</h2>
      <p>
        We retain personal information only for as long as necessary to fulfill
        the purposes outlined in this policy, or as required by law or
        regulatory obligations.
      </p>

      <h2 className="mt-5">6. Your Rights</h2>
      <p>Depending on applicable laws, you may have the right to:</p>
      <ul>
        <li>Access or request a copy of the information we hold about you.</li>
        <li>Request correction or updates to your personal information.</li>
        <li>
          Withdraw consent where processing is based on consent (where
          applicable).
        </li>
        <li>
          Request deletion of your data (subject to legal and regulatory
          obligations).
        </li>
      </ul>
      <p>
        To exercise these rights, please contact us using the details provided
        below.
      </p>

      <h2 className="mt-5">7. Cookies and Tracking Technologies</h2>
      <p>
        This website may use cookies or similar technologies to enhance user
        experience, track usage patterns, and improve performance. You can
        modify your browser settings to manage cookie preferences.
      </p>

      <h2 className="mt-5">8. Third-Party Links</h2>
      <p>
        Our platform may contain links to other websites. We are not responsible
        for the privacy practices of such third parties. We encourage you to
        read their privacy policies before submitting any personal information.
      </p>

      <h2 className="mt-5">9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. When we do, we will
        revise the "Effective Date" at the top. Significant changes will be
        communicated via the platform or other appropriate means.
      </p>

      <h2 className="mt-5">10. Contact Us</h2>
      <p>
        If you have any questions, concerns, or requests related to this Privacy
        Policy or your personal information, please contact:
      </p>
      <address>
        <strong>Nursing and Midwifery Council of Nigeria</strong>
        <br />
        Plot 713, Cadastral Zone Life Camp, Gwarinpa, Abuja
        <br />
        info@nmcn.gov.ng
        <br />
        +234 7029234588
      </address>
    </div>
  );
};

export default PrivacyPolicy;
